/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'


import {Typography, Card, CardMedia, CardContent, TextField, Button, IconButton, Divider, CardActions } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import { LoadingOverlay } from '../components/common'
import ChangePasswordForm from '../containers/user/ChangePasswordForm'
import ForgotPasswordForm from '../containers/user/ForgotPasswordForm'
import ValidateCaptcharModal from '../containers/captchar/ValidateCaptcharModal'
import { AppContext } from '../stores/AppStore'
import { UserContext } from '../stores/UserStore'
import { toast } from 'react-toastify'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  font-weight: bold;
`

const Login = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { logo } = useContext(AppContext)
  const { redirect, signIn, signOut, authState, setAuthState, applications, changePassword, sendRecoveryCode, recoverPassword, federatedSignIn, app, loadApp } = useContext(UserContext)
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [isLoading, setLoading] = useState(false)
  const [isOpen, setOpen] = useState(false)
  const [loginState, setLoginState] = useState('EMAIL')

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  useEffect(() => {
    if (app) {
      if (authState === 'SIGNED_IN' || authState === 'FORGOT_PASSWORD' || authState === 'NEW_PASSWORD_REQUIRED') {
        setLoading(false)
        setOpen(authState === 'SIGNED_IN')
      }
    }  
  }, [app, authState]) 

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }        

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }        

  const onBackClick = () => {
    if (authState === 'LOGIN') {
      setLoginState('EMAIL')
    } else if (authState === 'FORGOT_PASSWORD' || authState === 'NEW_PASSWORD_REQUIRED') {
        setAuthState('LOGIN')
    }
  }

  const onContinueClick = () => {
    if (email.toLowerCase().endsWith('@vallourec.com') || 
        email.toLowerCase().endsWith('@ext.vallourec.com') || 
          email.toLowerCase().endsWith('@vamfieldservice.com') || 
            email.toLowerCase().endsWith('@vamservices.com') || 
            email.toLowerCase().endsWith('@vam-usa.com') || 
              email.toLowerCase().endsWith('@ext.vallourec.net')) {
      setLoading(true)
      federatedSignIn().then((loggedIn) => {
        console.log(loggedIn)
        setLoading(loggedIn)
      }).catch((errorMessage) => {
        toast.error(errorMessage)
        setLoading(false)
      })
    } else {    
      setLoginState('LOGIN')
    }
  }

  const onSignInClick = () => {
    console.log('loginUserEvent')
    setLoading(true)
    signIn(email, password, true).then((loggedIn) => {
      console.log(loggedIn)
    }).catch((errorMessage) => {
      toast.error(errorMessage)
      setLoading(false)
    })
  }

  const onSignUpClick = () => {
    history.push('/register?app='+app.id)
  }

  const onForgotPasswordClick = () => {
    setAuthState('FORGOT_PASSWORD')
  }

   const onCaptcharChange = (value) => {
    if (value) {
      setLoading(true)
      redirect(value).then(() => { setLoading(true) })  
    }
  }

  const updateValue = (setFunction) => (e) => {
    setFunction(e.target.value)
  }

  return (
    <Background>
      <Card sx={{ width: '50vw', maxWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <LoadingOverlay borderRadius="card" visible={isLoading}/>
          <CardMedia image={logo} component="img" sx={{ width: '10vw', margin: '40px 20px 0px 40px' }} title="Logo..."/>
          { authState === 'FORGOT_PASSWORD' ? 
              <ForgotPasswordForm {...{ setLoading, email, setEmail, updateValue, sendRecoveryCode, recoverPassword, onBackClick }} />
            : authState === 'NEW_PASSWORD_REQUIRED' ?
              <ChangePasswordForm {...{ setLoading, updateValue, changePassword, signOut, onBackClick }} />
            : <>
            { loginState === 'EMAIL' ? <><CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '0px 20px' }} >
                  <Typography variant="h6" color="textSecondary" component="h2" sx={{ marginBottom: '30px'}}>Welcome to {app && app.label}</Typography>
                  <TextField id="email" name="email" type="email" label="Email" value={email} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleEmailChange}  error={email !== undefined && !email} sx={{ marginBottom: '20px'}} />
                  <Button disabled={!email} fullWidth variant="contained" onClick={onContinueClick}>Continue</Button>
                </CardContent>
                <Divider light sx={{ width: '100%'}} />          
                <CardActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0px' }}>
                  <Typography variant="body2" color="textPrimary" component="h6">© 2021 - 2022 {process.env.REACT_APP_COPYRIGHT}</Typography>
                </CardActions>
              </>
            :
              <><CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '20px', marginTop: '0px' }} >
                  <Typography variant="h6" color="textSecondary" component="h2" sx={{ marginBottom: '30px'}}>
                    <IconButton aria-label="back" onClick={onBackClick}><ArrowBackIcon /></IconButton>
                    Sign In with External Account
                  </Typography>
                  <TextField id="email" name="email" type="email" label="Email" value={email} readOnly fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  sx={{ marginBottom: '20px'}} />                        
                  <TextField id="password" name="password" label="Password" type="password" value={password} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handlePasswordChange}  error={password !== undefined && !password } sx={{ marginBottom: '0px'}} />                        
                  <Button size="small" sx={{ marginBottom: '20px', alignSelf: 'flex-end'}} onClick={onForgotPasswordClick}>{t('sng-sign-in.forget-password-label')}</Button>
                  <Button disabled={!email || !password} fullWidth variant="contained" onClick={onSignInClick}>Sign In</Button>
              </CardContent> 
              <Divider light sx={{ width: '100%'}} />          
              <CardActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0px' }}>
                <Typography variant="body2" color="textPrimary" component="h6">{t('sng-sign-in.footer-title')}</Typography>
                <Button size="small" onClick={onSignUpClick}>{t('sng-sign-in.register-label')}</Button>
              </CardActions>
            </>}                  
          </> }
'      </Card>      
      <ValidateCaptcharModal isOpen={isOpen} isLoading={isLoading} onChange={onCaptcharChange} />       
    </Background>
  )
}

export default Login